/**
 * Where the divider goes, given the feed's date groups: just below the last
 * upcoming group. Null when every group is upcoming or every group is past, since
 * there's no boundary to draw.
 *
 * Counts back from the *last* upcoming group rather than forward to the first past
 * one. Each group resolves its day in its own entries' frame — a clinic's for
 * clinic-bound records, the viewer's for the rest — so a feed mixing the two can
 * carry a past group above an upcoming one, and "first past group" would then cut
 * the upcoming run in half.
 */
export function nowDividerIndex(groups: { isFuture: boolean }[]): number | null {
  const index = groups.map((g) => g.isFuture).lastIndexOf(true) + 1
  return index > 0 && index < groups.length ? index : null
}

/**
 * Marks where a reverse-chronological feed's upcoming entries end and the record
 * of what actually happened begins.
 */
export function TimelineNowDivider() {
  return (
    <div className="mb-6 flex items-center gap-3">
      <div className="h-px flex-1 bg-foreground/20" />
      <span className="shrink-0 text-sm font-semibold tracking-wide text-muted-foreground uppercase">
        Now
      </span>
      <div className="h-px flex-1 bg-foreground/20" />
    </div>
  )
}
